import ImpactedServiceAlert, { withImpactedServiceAlert } from './ImpactedServiceAlert';

export default ImpactedServiceAlert;

export { withImpactedServiceAlert };
